<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card v-if="sensor != null" outlined @click="onClickSensor(sensor)" :color="sensor.isVisible ? 'primary' : 'white'" >
        <v-card style="margin:2px" outlined >
            <table style="width:100%;" :class="sensorData.backColor + ' ' + sensorData.foreColor">
                <tr>
                    <td style="text-align:center; width:100%;">
                        <h3>{{sensorData.name}}<span v-if="!sensorData.enabled">(無効)</span></h3>
                    </td>
                </tr>
                <tr>
                    <td>
                        <v-divider />
                    </td>
                </tr>
                <tr v-if="lastRecord != null">
                    <td style="text-align:center" colspan="2">
                        <span v-if="sensorData.enabled" style="font-family:Orbitron; font-size:40px; ">{{sensorData.value}}</span>
                        <span v-else style="font-family:Orbitron; font-size:40px; ">--.-</span>
                        <span style="font-size:20px; font-weight:bold">{{sensorData.unit}}</span>
                    </td>
                </tr>
                <!-- <template v-if="sensor.measureInformation != null">
                    <tr style="font-size:small">
                        <td class="text-right">最高</td>
                        <td class="text-center">{{sensor.measureInformation.max.toFixed(1)}}{{sensor.body.unit}}</td>
                    </tr>
                    <tr style="font-size:small">
                        <td class="text-right">最低</td>
                        <td class="text-center">{{sensor.measureInformation.min.toFixed(1)}}{{sensor.body.unit}}</td>
                    </tr>
                    <tr style="font-size:small">
                        <td class="text-right">平均</td>
                        <td class="text-center">{{sensor.measureInformation.average.toFixed(1)}}{{sensor.body.unit}}</td>
                    </tr>
                </template> -->
            </table>
        </v-card>
        <!-- <Maintenance ref="sensorMaintenance" @onUpdatedSensor="onUpdatedSensor" /> -->
    </v-card>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Maintenance from '@/components/box/MaintenanceSensor';
    export default {
        components: {
            Maintenance
        },
        props: {
            sensor: null,
            readonly: false
        },
        data: function () {
            return {
                lastRecord: null,
                lastAlarms: null,
                recordListenerReleaser: null,
                alarmListenerReleaser: null,
                currentAlarm: null
            }
        },
        computed: {
            sensorData: function () {
                const data = {
                    backColor: "",
                    foreColor: "",
                    enabled: this.sensor.body.enabled,
                    name: this.sensor.body.name,
                    value: "",
                    unit: this.sensor.body.unit
                }

                console.log(data)

                if (this.lastRecord != null) {

                    data.value = this.lastRecord.value.toFixed(1)

                    console.log("SensorCurrentValue", "(computed)sensorData", this.sensor.body.sensorKey, this.lastAlarms, this.lastRecord)

                    if (this.lastAlarms != null) {
                        var lastAlarm = null
                        if (this.lastAlarms.box != null && this.lastAlarms.sensors[this.sensor.body.sensorKey] == null) {
                            lastAlarm = this.lastAlarms.box
                            console.log("SensorCurrentValue", "(computed)sensorData", "last alarm box", lastAlarm)
                        } else if (this.lastAlarms.box == null && this.lastAlarms.sensors[this.sensor.body.sensorKey] != null) {
                            lastAlarm = this.lastAlarms.sensors[this.sensor.body.sensorKey]
                            console.log("SensorCurrentValue", "(computed)sensorData", "last alarm sensor", lastAlarm)
                        } else {
                            const lastBoxAlarmTime = this.lastAlarms.box == null ? 0 : this.lastAlarms.box.time
                            const lastSensorAlarmTime = this.lastAlarms.sensors[this.sensor.body.sensorKey] == null ? 0 : this.lastAlarms.sensors[this.sensor.body.sensorKey].time
                            if (lastBoxAlarmTime > lastSensorAlarmTime) {
                                lastAlarm = this.lastAlarms.box
                                console.log("SensorCurrentValue", "(computed)sensorData", "last alarm box", lastAlarm)
                            } else {
                                lastAlarm = this.lastAlarms.sensors[this.sensor.body.sensorKey]
                                console.log("SensorCurrentValue", "(computed)sensorData", "last alarm sensor", lastAlarm)
                            }
                        }

                        const lastRecordTime = (new Date(this.lastRecord.dateTime.replace(/-/g, "/"))).getTime()
                        
                        if (lastAlarm != null && lastAlarm.time > lastRecordTime) {
                            if (lastAlarm.sensorKey == null) {
                                // BOXの異常時
                                // 測定値は表示せずに、背景色を赤、文字色を白
                                data.value = "-----"
                                data.unit = ""
                                data.backColor = "red"
                                data.foreColor = "white--text"
                                data.alarm = lastAlarm
                                return data
                            }
                            switch (lastAlarm.alarmType) {
                                case 3:
                                    // センサー異常時
                                    // 測定値は表示せずに、文字色を赤
                                    data.value = "-----"
                                    data.unit = ""
                                    data.foreColor = "red--text"
                                    data.alarm = lastAlarm
                                    return data
                                default:
                                    // 上限、下限異常時
                                    // 文字色を赤
                                    data.foreColor = "red--text"
                                    data.alarm = lastAlarm
                                    return data
                            }
                        }
                    }

                }
                return data
            }
        },
        mounted: function () {            
            const self = this
            // センサーの最後の値がセットされるドキュメントを監視する
            this.recordListenerReleaser = db.collection("environments").doc(this.sensor.boxMaster.boxIdentificationCode)
            .collection("sensors").doc(this.sensor.body.sensorKey)
            .collection("records").doc("last").onSnapshot(function(doc) {
                self.lastRecord = doc.data()
            })
            // 異常のドキュメントを監視
            const currentDate = new Date()
            this.alarmListenerReleaser = db.collection("environments").doc(this.sensor.boxMaster.boxIdentificationCode)
            .collection("alarm_histories").doc("lastAlarms")
            .onSnapshot(function(doc){
                self.lastAlarms = doc.data()
            })
        },
        beforeDestroy: function () {
            if (this.recordListenerReleaser != null) {
                this.recordListenerReleaser()
                console.log("listener destroyed")
            }
            if (this.alarmListenerReleaser != null) {
                this.alarmListenerReleaser()
                console.log("listener destroyed")
            }
        },
        methods: {
            onClickSensor: function (sensor) {
                if (this.readonly) return
                this.sensor.isVisible = !this.sensor.isVisible
            }
        }
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Orbitron&display=swap');
</style>
